import React from 'react';

function AboutMe() {
  return (
    <section id="about" className="about">

      <div className="about-bg-circle circle-1" aria-hidden="true" />
      <div className="about-bg-circle circle-2" aria-hidden="true" />

      <div className="about-container">

        {/* ── SECTION HEADER ── */}
        <div className="section-header">
          <span className="section-tag">Get to know me</span>
          <h2 className="section-title">
            About <span className="title-highlight">Me</span>
          </h2>
          <div className="section-divider" />
        </div>

        {/* ── MAIN CONTENT GRID ── */}
        <div className="about-grid">

          {/* LEFT — Photo + quick facts */}
          <div className="about-photo-col">
            <div className="about-photo-frame">
              <img
                src={require('./image/picko.jpg')}
                alt="Alessandra R. Abuque"
                className="about-photo"
              />
              <div className="frame-accent accent-tl" aria-hidden="true" />
              <div className="frame-accent accent-br" aria-hidden="true" />
            </div>

            <div className="quick-facts">
              <div className="fact-card">
                <span className="fact-icon">🎓</span>
                <div>
                  <p className="fact-label">Degree</p>
                  <p className="fact-value">BS Computer Engineering</p>
                </div>
              </div>
              <div className="fact-card">
                <span className="fact-icon">📅</span>
                <div>
                  <p className="fact-label">Age & Year Level</p>
                  <p className="fact-value">22 yrs old · 3rd Year</p>
                </div>
              </div>
              <div className="fact-card">
                <span className="fact-icon">🏛️</span>
                <div>
                  <p className="fact-label">Organization Role</p>
                  <p className="fact-value">VP for Academic Affairs · ICPEP.SE-FC</p>
                </div>
              </div>
              <div className="fact-card">
                <span className="fact-icon">💼</span>
                <div>
                  <p className="fact-label">Status</p>
                  <p className="fact-value">Open to Opportunities</p>
                </div>
              </div>
              <div className="fact-card">
                <span className="fact-icon">⭐</span>
                <div>
                  <p className="fact-label">Interest</p>
                  <p className="fact-value">Biomedical Technology & Healthcare Systems</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT — Text content */}
          <div className="about-text-col">

            {/* ── 1. SELF-INTRODUCTION ── */}
            <div className="about-block">
              <div className="block-label">
                <span className="block-dot dot-pink" />
                Who I Am
              </div>
              <h3 className="block-heading">
                Hello, I'm <span className="name-pink">Alessandra R. Abuque</span> 
              </h3>
              <p className="block-text">
                I am Alessandra R. Abuque, a 22-year-old 3rd year BS Computer Engineering
                student with a deep passion for technology, leadership, and continuous
                learning. Beyond the classroom, I serve as the <strong>Vice President for
                Academic Affairs of ICPEP.SE-FC</strong>, where I try to bridge the gap
                between students and academic excellence in the field of computer engineering.
                I try to be always curious due to my ambition, and I'm committed to make a difference in our community.
              </p>
            </div>

            {/* ── 2. BACKGROUND ── */}
            <div className="about-block">
              <div className="block-label">
                <span className="block-dot dot-green" />
                My Background
              </div>
              <h3 className="block-heading">Computer Engineering Student</h3>
              <p className="block-text">
                Now in my 3rd year of BS Computer Engineering, I am slowly building my knowledge in both hardware and software,
                from programming and basic data structures to electronics and embedded systems. While managing my schoolwork and
                holding a leadership role in ICPEP.SE-FC, I have improved not only my technical skills but also my ability to organize,
                communicate, and lead under pressure. Each semester brings new challenges that help me grow as a student and as a future engineer.
              </p>
            </div>

            {/* ── 3. WHY COMPUTER ENGINEERING ── */}
            <div className="about-block">
              <div className="block-label">
                <span className="block-dot dot-pink" />
                Why Computer Engineering?
              </div>
              <p className="block-text">
                To be honest, at first, I chose Computer Engineering because it was one of the top paying jobs in the Philippines. 
                Now, I stayed because I enjoy learning new things since I really did not have knowledge before going to college. In the process of being surrounded by technology,
                I've become the person who wanted to understand how things worked, not just use
                them. CpE gave me the perfect path to explore both the physical side of
                computing and the world of software, and now I know that this is
                exactly where I belonged. It is a field that never stops evolving, and
                that constant challenge is what excites me the most.
              </p>
            </div>

            {/* ── 4. FIELD OF INTEREST ── */}
            <div className="about-block">
              <div className="block-label">
                <span className="block-dot dot-green" />
                What Interests Me Most
              </div>
              <p className="block-text">
                My strongest interest lies in the biomedical field, where engineering and healthcare come together to improve lives. 
                I am fascinated by how technology can be used to develop innovative solutions for medical challenges, from diagnostic 
                tools to patient care systems. I am especially interested in the growing role of artificial intelligence in healthcare 
                and how it is transforming the way diseases are detected and treated. The idea of creating technology that can directly 
                impact people’s health and well-being motivates me to keep learning, exploring, and pushing myself to grow in this field.
              </p>
            </div>

            {/* ── 5. CAREER GOALS ── */}
            <div className="about-block">
              <div className="block-label">
                <span className="block-dot dot-pink" />
                Career Goals & Aspirations
              </div>
              <h3 className="block-heading">What I Want to Become</h3>
              <p className="block-text">
                My goal is to become a skilled and well-rounded professional in the biomedical field who creates technologies that
                improve healthcare and are accessible to many people. Next school year, I aim to gain real-world experience through
                internships and personal projects that will help me grow my skills. In the long term, I hope to take on leadership 
                roles where I can guide teams, support innovation, and contribute to projects that truly help improve people’s health 
                and quality of life. I also hope to stay connected with the academic community and inspire future Computer Engineering 
                students, just as my mentors and ICPEP have inspired me.

              </p>
            </div>

            {/* ── 6. PERSONAL STRENGTHS ── */}
            <div className="about-block">
              <div className="block-label">
                <span className="block-dot dot-green" />
                Personal Strengths
              </div>
              <div className="strengths-grid">
                <div className="strength-pill pill-pink">💡 Problem Solver</div>
                <div className="strength-pill pill-green">⚡ Fast Learner</div>
                <div className="strength-pill pill-pink">🤝 Team Leader</div>
                <div className="strength-pill pill-green">🎯 Detail-Oriented</div>
                <div className="strength-pill pill-pink">🎨 Creative Thinker</div>
                <div className="strength-pill pill-green">🔄 Adaptable</div>
              </div>
            </div>

            {/* ── CTA ── */}
            <div className="about-cta">
              <a href="#projects" className="btn btn-primary">
                See My Projects
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
              <a href="#contact" className="btn btn-outline">Contact Me</a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMe;